import http from '../http'

export function fetchSalesPeriod(id) {
    return http.request({
        url: '/adminapi/sales-period/' + id,
        method: 'get'
    })
}
